// @flow

import { Component } from '~/sources/scripts/jsti/core';
import Notifications from '../constants/Notifications';
import EventNames from '../constants/EventNames';

export default class ProductVariantSelector extends Component {
  #sku: string;
  activeClasses: string[];
  inactiveClasses: string[];

  /**
   * Instantiate the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    if (!this.el.dataset.sku) {
      throw new Error('A sku is required');
    }
    this.#sku = this.el.dataset.sku;

    if (!this.el.dataset.activeClass || !this.el.dataset.inactiveClass) {
      throw new Error('Classes are required');
    }
    this.activeClasses = this.el.dataset.activeClass.split(' ');
    this.inactiveClasses = this.el.dataset.inactiveClass.split(' ');

    this.addListener(Notifications.SELECT_PRODUCT, this.onSelect.bind(this));

    this.addEventListener(EventNames.CLICK, () => {
      this.notify(Notifications.SELECT_PRODUCT, { sku: this.#sku });
    });
  }

  /**
   * Executes when a product gets selected
   */
  onSelect({ sku }: { sku: string }): void {
    if (sku !== this.#sku) {
      this.el.classList.add(...this.inactiveClasses);
      this.el.classList.remove(...this.activeClasses);
      return;
    }

    this.el.classList.add(...this.activeClasses);
    this.el.classList.remove(...this.inactiveClasses);
  }
}
